// Order matters for the statistics tiles
export enum STATISTICS_TYPES {
  TOTAL_SESSIONS_DURATION = 'TOTAL_SESSIONS_DURATION',
  MAX_CONNECTION_STREAK = 'MAX_CONNECTION_STREAK',
  NB_MEETINGS = 'NB_MEETINGS',
  ASSIGNMENTS = 'ASSIGNMENTS',
  COMPLETED_SEQUENCES = 'COMPLETED_SEQUENCES',
  DOWNLOADED_SEQUENCES = 'DOWNLOADED_SEQUENCES',
  NB_RESOURCES_SEEN = 'NB_RESOURCES_SEEN',
  NB_AUDIO_LISTENED = 'NB_AUDIO_LISTENED',
  NB_VIRTUAL_CLASSROOMS_SEEN = 'NB_VIRTUAL_CLASSROOMS_SEEN',
  NB_REPLAYS_SEEN = 'NB_REPLAYS_SEEN',
  EXERCISES = 'EXERCISES',
}

export enum STATISTICS_TILES_TYPES {
  GENERAL = 'GENERAL',
  PROGRESSION = 'PROGRESSION',
  VIRTUAL_CLASSROOMS = 'VIRTUAL_CLASSROOMS',
  ASSIGNMENTS = 'ASSIGNMENTS',
}
export * from './model';
